import { render, staticRenderFns } from "./DeckSingleComment.vue?vue&type=template&id=e9997908&"
import script from "./DeckSingleComment.vue?vue&type=script&lang=js&"
export * from "./DeckSingleComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports